
import * as Style from './styles';
import iconStandardLocation from '../../assets/AddressList/iconStandardLocation.svg'
import iconLocation from '../../assets/AddressList/iconLocation.svg'

export const PublicPlace = ({listItem}) => {
    return(
        <Style.WrapperPublicPlace standard={listItem.padrao}>  
            <img src={listItem.padrao === "S" ?  iconStandardLocation : iconLocation} alt={'ícone de localização'}/> 
            <p>{listItem.logradouro}</p>

        </Style.WrapperPublicPlace>
    )
}